import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { RankMutationKeys } from '../../../keys'
import { CreateRankRequest, CreateRankResponse } from '../../../type'
import { createRank } from '../../services'

interface CreateRankParams {
	payload: CreateRankRequest
}

export default function useMutationCreateRank(
	props?: UseBaseMutationOptions<CreateRankResponse, CreateRankParams>,
) {
	return useMutation({
		mutationKey: [RankMutationKeys.CreateRank],
		mutationFn: (params) => createRank(params.payload),
		...props,
	})
}
